export const PATHS = {
  KEY_CONTACTS: `key-contacts`,
  POLICIES: `policies`,
  POLICY_LOOKUP: `lookup-policy`,
  REFERRALS: `referrals`,
  CLAIMS: `claims`,
}
